import React from 'react'
import verifiedIcon from '../../assets/icons/verified.svg'
import verifiedIconDark from '../../assets/icons/verified-dark.svg'
import Text from "../i18n/Text";

export default function CaseGoneInfo() {
    return <div className="d-flex flex-column justify-content-center align-items-center">
        <img src={verifiedIcon} alt="verified" className="dark-img m-4 mw-100"
             style={{width: '80px'}} data-test-id="0df48425-8be9"/>
        <img src={verifiedIconDark} alt="verified" className="light-img m-4 mw-100"
             style={{width: '80px'}} data-test-id="34anlfjqvsc4"/>
        <h1 data-test-id="2ed6b9dc-1496"><Text k='common.thank'/></h1>
        <p data-test-id="2654a2e1-f332">
            <Text k="case.gone"/>
        </p>
    </div>
}